import React from 'react';
import './NotFound.css';

function NotFound() {
  return (
    <div className="NotFound">
      <div className="NotFound-content">
        <h1 className="NotFound-title">404</h1>
        <h2 className="NotFound-subtitle">Page Introuvable</h2>
        <p className="NotFound-description">
          Désolé, la page que vous recherchez n'existe pas.
        </p>
        <a href="/" className="NotFound-button">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
}

export default NotFound;
